/**
 * Adzuki.TableSorter
 *
 * Client side table sorter: https://cruisesystem.sharepoint.com/sites/CPBookofKnowledge/SitePages/Table-Sorter---Client-Side.aspx
 * Server side table sorter: https://confluence.cruiseplannersnet.com/display/TDG/Table+Sorter+-+Server+side
 */

(function TableSorter($, Adzuki)
{
	"use strict";

	var TableSorter = {};
	var arrow_up    = '<i class="' + Adzuki.FaIcon.getIconStyle('arrow_up') + '"></i>';
	var arrow_down  = '<i class="' + Adzuki.FaIcon.getIconStyle('arrow_down') + '"></i>';

	// used for client-side table sorting
	TableSorter.initClientSide = function init($table_elem)
	{
		if ($table_elem.is('table')) {
			$table_elem.stupidtable();
			_setTableHeaders($table_elem);
		} else if ($table_elem.is('ul')) {
			_initClientSort($table_elem);
		} else {
			console.warn('[Adzuki.TableSorter] - table element used is not valid');
		}
	};

	// used for server-side table sorting
	TableSorter.initServerSide = function init($table_elem)
	{
		if ($table_elem.is('ul')) {
			_initServerSort($table_elem);
		} else {
			console.warn('[Adzuki.TableSorter] - table element used is not valid');
		}
	};

	// used for ajax based table sorting
	TableSorter.initAjax = function init($container)
	{
		var $table_elems = $container.find('.table-sort-ajax');

		if ($table_elems.length === 0) {
			console.warn('[Adzuki.TableSorter] - table element used is not valid');
			return;
		}

		$table_elems.each(function onEachTable(i, el) {
			_initServerSort($(el), $container, true);
		});
	};

	function _getRowValue($row_elem, index)
	{
		var val = null;

		$row_elem.children().each(function onEachChildren(i, elem)
		{
			if (i === index) {
				$(elem).children().each(function onEachChild(j, child)
				{
					var sort_data = $(child).data('sort-value');
					if (sort_data !== undefined) {
						if (sort_data === "") {
							val = $(child).text();
						} else {
							val = sort_data;
						}
						return false; // break out of this loop
					}
				});
				return false; // break out of this loop
			}
		});

		return val;
	}

	function _initClientSort($table)
	{
		var mode = 'asc';

		$table.find('.table-header p').each(function onEachHeader(i, elem)
		{
			if ($(elem).data('sort')) {
				$(elem).css('cursor', 'pointer');
				$(elem).html($(elem).html() + ' ' + arrow_up);
				$(elem).find('i:not(".adzicon-question")').addClass('hidden');

				// check for default sorting
				if ($(elem).hasClass('order')) {
					if ($(elem).hasClass('desc')) {
						// default sorting is descending
						$(elem).find('i:not(".adzicon-question")').removeClass('fa-arrow-up');
						$(elem).find('i:not(".adzicon-question")').addClass('fa-arrow-down');
					} else {
						// default sorting is ascending
						$(elem).find('i:not(".adzicon-question")').removeClass('fa-arrow-down');
						$(elem).find('i:not(".adzicon-question")').addClass('fa-arrow-up');
					}

					$(elem).find('i:not(".adzicon-question")').removeClass('hidden');
				}

				$(elem).click(function onHeaderClick(e)
				{
					var $self = $(this);
					var $icon = $(this).find('i:not(".adzicon-question")');

					$table.find('.table-header p').removeClass('order');
					$table.find('.table-header p i:not(".adzicon-question")').addClass('hidden');
					$icon.removeClass('hidden');

					if ($icon.hasClass('fa-arrow-up')) {
						mode = 'asc';

						$self.addClass('order');
						$icon.removeClass('fa-arrow-up')
							.addClass('fa-arrow-down');
					} else {
						mode = 'desc';

						$self.addClass('order');
						$icon.removeClass('fa-arrow-down')
							.addClass('fa-arrow-up');
					}

					_sortTable($table, $(this), mode, i);
				});
			}
		});
	}

	function _initServerSort($table, $container, is_ajax = false)
	{
		var loading_ani = null;

		if ($container) {
			loading_ani = $container.data('loading-animation');
		}

		$table.find('.table-header > p').each(function onEachHeader(i, elem)
		{
			// ignore columns that are not meant to be sorted
			if ($(elem).hasClass('no-sort')) {
				return; // continue
			}

			$(elem).off().on('click', function onHeaderClick(e)
			{
				var $self      = $(this);
				var order      = 'asc';
				var order_icon = arrow_up;
				var url        = '';

				// clicked on the same header again, invert the order
				if ($self.hasClass('asc')) {
					order      = 'desc';
					order_icon = arrow_down;
				} else if ($self.hasClass('desc')) {
					order      = 'asc';
					order_icon = arrow_up;
				}

				if ($self.data('sort-url')) {
					url = $self.data('sort-url');
				}

				$table.find('.table-header > p').each(function updateHeaders(j, header_elem)
				{
					$(header_elem).removeClass('order asc desc')
					.find('i:not(".adzicon-question")').first().remove();
				});

				$self.addClass('order');

				if (order !== '') {
					$self.addClass(order);
				}

				$self.html($self.html() + ' ' + order_icon);

				if (is_ajax) {
					if ($container) {
						if (loading_ani) {
							$container.css('opacity', '0.4');
							$container.prepend('<span class="pagination-loading"> <i class="fa fa-spinner fa-spin fa-2x"></i></span>');
						}

						Adzuki.Ajax.get(url)
						.then(function renderContents(response) {
							$container.html(response);

							if (loading_ani) {
								$container.css('opacity', '1');
							}

							// This can be used by client code to trigger a callback after ajax content loaded
							$container.trigger('table-sort-ajax.loaded');

							// ajax content re-loaded, re-init the sorting
							TableSorter.initAjax($container);
						});
					}
				} else {
					window.location.href = url;
				}
			});
		});
	}

	function _setTableHeaders($table)
	{
		$table.find('thead tr th').each(function onEachTh(i, elem)
		{
			$(elem).css('cursor', 'pointer');
			$(elem).html($(elem).html() + ' ' + arrow_up);
			$(elem).find('i:not(".adzicon-question")').addClass('hidden');
		});

		$table.bind('aftertablesort', function afterTableSort(e, data)
		{
			var $th   = data.$th;
			var $icon = $th.find('i:not(".adzicon-question")');

			$(this).find('thead tr th i:not(".adzicon-question")').addClass('hidden');
			$icon.removeClass('hidden');

			if (data.direction === 'asc') {
				$icon.removeClass('fa-arrow-down')
					.addClass('fa-arrow-up');
			} else {
				$icon.removeClass('fa-arrow-up')
					.addClass('fa-arrow-down');
			}
		});
	}

	function _sortRows(a, b, mode)
	{
		var aVal;
		var bVal;

		if (a.type === 'string') {
			aVal = a.val.toString().toUpperCase();
			bVal = b.val.toString().toUpperCase();

			if (aVal < bVal) {
				return (mode === 'desc') ? -1 : 1;
			} else if (aVal > bVal) {
				return (mode === 'desc') ? 1 : -1;
			}
			return 0;
		} else if (a.type === 'int') {
			aVal = parseInt(a.val);
			bVal = parseInt(b.val);

			if (mode === 'desc') {
				return aVal - bVal;
			}
			return bVal - aVal;
		} else if (a.type === 'float') {
			aVal = parseFloat(a.val);
			bVal = parseFloat(b.val);

			if (mode === 'desc') {
				return aVal - bVal;
			}
			return bVal - aVal;
		}
	}

	function _sortRowsAsc(a, b)
	{
		return _sortRows(a, b, 'asc');
	}

	function _sortRowsDesc(a, b)
	{
		return _sortRows(a, b, 'desc');
	}

	function _sortTable($table, $header_elem, mode, index)
	{
		var items    = [];
		var val_type = $header_elem.data('sort');

		$table.find('.table-row').each(function onEachRow(i, row_elem)
		{
			var row_val = _getRowValue($(row_elem), index);
			var item    = {
				row : $(row_elem).clone(true),
				val : row_val,
				type: val_type,
			};
			items.push(item);
		});

		if (mode === 'asc') {
			items.sort(_sortRowsAsc);
		} else {
			items.sort(_sortRowsDesc);
		}
		$table.find('.table-row').remove();

		$.each(items, function onEachItem(i, item) {
			$table.append(item.row);
		});
	}

	Adzuki.TableSorter = TableSorter;
}(jQuery, window.Adzuki || {}));
